import React from "react";
//import CanvasJSReact from '../../Assets/canvasjs.react'
//var CanvasJSChart = CanvasJSReact.CanvasJSChart;
import { MDBSimpleChart, MDBCard, MDBCardBody, MDBCol, MDBRow} from "mdbreact";

class GoalChart extends React.Component {
    constructor(props) {
        super(props);

    }
    render() {
        return (
            
            <MDBCol md={ this.props.setCols == "1" ? "4" : "12"} sm="12" className="mb-r" >
                    <MDBCard style={{ marginBottom: "7px" }}>
                        <MDBCardBody>
                            <div className="data" class="text-center">
                            <p style={{fontSize:"15px"}}><strong>{this.props.goalTitle}</strong></p>
                            <p style={{ fontSize: "13px" }}>Goal: { this.props.goalValue}</p>
                            <p style={{ fontSize: "13px" }}>Progress: {this.props.progress}</p>
                            <hr />
                            <MDBRow>
                                <MDBCol md="6" sm="12">
                            <MDBSimpleChart
                                width={100}
                                height={100}
                                strokeWidth={4}
                                percent={this.props.goalPercentage}
                                strokeColor={ this.props.color}
                                labelFontWeight="300"
                                labelColor="#000"
                                    />
                                </MDBCol>
                                <MDBCol md="6" sm="12">
                                    <p style={{ fontSize: "13px" }}>Shortfall: {this.props.shortFall}</p>
                                    <p style={{ fontSize: "13px" }}>Over: { this.props.over}</p>
                                    </MDBCol>
                                </MDBRow>
                        </div>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
                
           
        );
    }
}

export default GoalChart;